var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FieldItem",
    { attrs: { id: _vm.id, label: _vm.$t(_vm.fieldConfig.label) } },
    [
      _c(
        "div",
        { staticClass: "search-summary__block" },
        _vm._l(_vm.SEQUENCE_TYPES, function (t) {
          return _c("div", { key: t, staticClass: "search-summary__option" }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fieldValue,
                    expression: "fieldValue",
                  },
                ],
                attrs: { type: "radio" },
                domProps: { value: t, checked: _vm._q(_vm.fieldValue, t) },
                on: {
                  change: [
                    function ($event) {
                      _vm.fieldValue = t
                    },
                    _vm.syncChange,
                  ],
                },
              }),
              _c("span", [
                _vm._v(
                  " " + _vm._s(_vm.$t("Search.btns." + t.toLowerCase())) + " "
                ),
              ]),
            ]),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }